import _JSXStyle from "styled-jsx/style";
import { colors, spacers } from '@dhis2/ui-constants';
import PropTypes from 'prop-types';
import React from 'react';
const FileListPlaceholder = _ref => {
  let {
    children,
    dataTest = 'dhis2-uicore-filelistplaceholder'
  } = _ref;
  return /*#__PURE__*/React.createElement("p", {
    "data-test": dataTest,
    className: _JSXStyle.dynamic([["1287857385", [spacers.dp4, colors.grey700]]])
  }, children, /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "1287857385",
    dynamic: [spacers.dp4, colors.grey700]
  }, [`p.__jsx-style-dynamic-selector{margin:0;padding-top:${spacers.dp4};font-size:14px;color:${colors.grey700};}`]));
};
FileListPlaceholder.propTypes = {
  children: PropTypes.string,
  dataTest: PropTypes.string
};
export { FileListPlaceholder };